import { render, staticRenderFns } from "./InputColorPalette.vue?vue&type=template&id=03b3c76c&"
import script from "./InputColorPalette.vue?vue&type=script&lang=ts&"
export * from "./InputColorPalette.vue?vue&type=script&lang=ts&"
import style0 from "./InputColorPalette.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports